import styled from 'styled-components';

interface SliderStyleProps {
  $value: number;
  $min: number;
  $max: number;
}

const FieldWrapper = styled.div`
	display: flex;
	gap: 14px;
	justify-content:space-between;
	align-items:center;

	@media (max-width: 540px) {
		gap: 5px;
	}
`;

const Label = styled.span`
  font-size: .85rem;
	line-height: 1;
	font-family: 'Inter';
	font-weight: 500;
	color: var(--textColor);
	transition: color 0.2s ease;
`;

const InputBox = styled.label`
  display: flex;
  align-items: center;
  background: var(--inputBgColor);
  padding: 0px;
  cursor: pointer;
	width: 108px;
	border: 1px solid var(--borderColor);
	border-radius: 2px;
	overflow: hidden;

	transition: border-color 0.2s ease, box-shadow 0.2s ease; 

	@media (max-width: 540px) {
		width:80px;
		min-width: 80px;
	}

	input{
		line-height: 1;
    font-size: 0.85rem;
    padding: 4px 6px 4px 12px;
    background: transparent;
		border: none;
    border-right: 1px solid rgb(204 204 204 / 31%);
    border-radius: 0px;
    outline: none;
		transition: border-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease;

		@media (max-width: 540px) {
			padding-left: 6px;
		}

		&:focus{
			background: var(--defaultBgColor);
		}
		&:disabled {
			cursor: not-allowed;
			opacity: 0.6;
		}
		&[type="number"]::-webkit-inner-spin-button,
		&[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
		}
		&[type="number"] {
			-moz-appearance: textfield;
			color-scheme: var(--colorScheme, light);
		}
	}
	&:has(input:disabled) {
		cursor: not-allowed;
	}

`;

const Unit = styled.span`
  margin-left: 10px;
	margin-right:10px;
  font-size: 14px;
  color: var(--subHeadingColor);
`;

const Slider = styled.input<SliderStyleProps>`
  width: 100%;
  margin-top: 6px;
  padding: 5px 0;
  appearance: none;
  cursor: pointer;
  height: 6px;
  border-radius: 10px;
  outline: none;

	background: ${({ $value, $min, $max }) => {
		const percentage = (($value - $min) / ($max - $min)) * 100;
		return `linear-gradient(to right, var(--primary) ${percentage}%, var(--toggleTrackColor) ${percentage}%)`;
	}};


  /* Thumb */
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    background: #ffffff;
    border-radius: 50%;
    border: none;
    box-shadow: 0 2px 6px rgba(0,0,0,0.25);
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 18px;
    height: 18px;
    background: #ffffff;
    border-radius: 50%;
    border: none;
    box-shadow: 0 2px 6px rgba(0,0,0,0.25);
    cursor: pointer;
  }

  &:hover::-webkit-slider-thumb {
    transform: scale(1.05);
  }

  &:focus::-webkit-slider-thumb {
    box-shadow: 0 0 0 6px rgba(0, 60, 255, 0.15);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    &::-webkit-slider-thumb { cursor: not-allowed; }
    &::-moz-range-thumb { cursor: not-allowed; }
  }
`;

const SliderWrap = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 10px 0px;
	div{
		color: var(--labelValueColor);
		font-size: 0.938rem;
		margin-bottom: 2px;
	}
`;

const ErrorText = styled.div`
  margin-top: 4px;
  font-size: 0.75rem;
  color: #ff4d4f;
`;

const FieldWrapperSlider = styled.div`
		display: flex;
		flex-direction: column;
		width:100%;

		&.active{
		border: var(--inputFocusBorderColor);

		span{
			color: var(--primary);
		}
		label{
			border-color: var(--inputFocusBorderColor);
		}
		input{
			border-color: var(--inputFocusBorderColor);
			color: var(--primary);
		}
	}

	/* ERROR STATE */
	&.error ${InputBox}{
		border-color: #ff4d4f;
		background: var(--errorBgColor);
	}

	&.error input{
		color: #ff4d4f;
		border-color: #ff4d4f;
	}

	&.error input:focus{
		box-shadow: 0 0 0 2px rgba(255,77,79,0.2);
	}

	&.error span{
		color: #ff4d4f;
	}
`;

export {
	Slider,
	Unit,
	InputBox,
	Label,
	FieldWrapper,
	SliderWrap,
	ErrorText,
	FieldWrapperSlider
};
